// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"7dbbe574","2089":"8ac255f9","3353":"7dbbe574","4744":"7dbbe574","8031":"7a4244d7","8491":"2070c431"}[chunkId] + ".chunk.css";
};